module.exports = __webpack_public_path__ + "./img/briefcase.a65c4b86ab6972b1ab37ef874360ef74.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/briefcase.png
// module id = ./src/containers/Briefcase/entry/icons/briefcase.png
// module chunks = 0